/**
 * Resolves the backend URL for API calls.
 * In production deployments, the frontend and backend share the same origin,
 * so we use window.location.origin. The env var is only used in development.
 */
function getBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // In production: use the current origin (same-origin deployment)
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return window.location.origin;
  }
  
  // In development: use the env var or localhost
  return envUrl || 'http://localhost:8001';
}

export const BACKEND_URL = getBackendUrl();
export const API = BACKEND_URL;
export default BACKEND_URL;
